import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Profile from './Profile';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data, wallet } = state.user;
  return {
    isLoading,
    data,
    wallet,
  };
}

const Styled = withStyles(styles)(Profile);

export default connect(
  mapStateToProps,
)(Styled);
